import { ACHTransferBatch } from '~/typings/API';

export type ACHBatchAmounts = {
  phase: 'validated' | 'created';
  credit: number;
  debit: number;
};

export const isACHBatchAllInvalid = (batch: ACHTransferBatch): boolean =>
  batch.status === 'validated' && batch.totalCount > 0 && batch.validationFailedCount === batch.totalCount;

export const isACHBatchAllFailed = (batch: ACHTransferBatch): boolean =>
  batch.status === 'completed' && batch.failedCount > 0 && batch.succeededCount === 0;

const isACHBatchPostCreation = (batch: ACHTransferBatch): boolean => !!batch.completedAt || batch.status === 'failed';

export const buildACHBatchBreakdownText = (batch: ACHTransferBatch): string => {
  let parts: { label: string; count: number }[] = [];
  if (isACHBatchPostCreation(batch)) {
    parts = [
      { label: 'Created', count: batch.succeededCount },
      { label: 'Failed', count: batch.failedCount },
      { label: 'Invalid', count: batch.validationFailedCount },
    ];
  } else if (batch.validatedAt) {
    parts = [
      { label: 'Validated', count: batch.totalCount - batch.validationFailedCount },
      { label: 'Invalid', count: batch.validationFailedCount },
    ];
  }
  return parts
    .filter((p) => p.count > 0)
    .map((p) => `${p.count} ${p.label}`)
    .join(' · ');
};

export const pickACHBatchAmounts = (batch: ACHTransferBatch): ACHBatchAmounts | null => {
  if (batch.status === 'canceled' || batch.status === 'expired') return null;
  if (isACHBatchAllInvalid(batch) || isACHBatchAllFailed(batch)) return null;
  if (isACHBatchPostCreation(batch)) {
    return { phase: 'created', credit: batch.totalCreditAmount, debit: batch.totalDebitAmount };
  }
  if (batch.validatedAt) {
    return {
      phase: 'validated',
      credit: batch.validatedTotalCreditAmount,
      debit: batch.validatedTotalDebitAmount,
    };
  }
  return null;
};
